import _extends from "@babel/runtime/helpers/extends";
/**
 * Copyright IBM Corp. 2016, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { useEffect, useRef } from 'react';
import Button from '../../internal/vendor/carbon-components-react/components/Button/Button';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings';
import settings from 'carbon-components/es/globals/js/settings';
var stablePrefix = ddsSettings.stablePrefix;
var prefix = settings.prefix;
/**
 * Button group.
 */

var ButtonGroup = function ButtonGroup(_ref) {
  var buttons = _ref.buttons;
  var groupRef = useRef(null);
  useEffect(function () {
    if (groupRef.current) {
      groupRef.current.style.setProperty("--".concat(stablePrefix, "--button-group--item-count"), String(buttons.length));
    }
  }, [buttons]);
  return React.createElement("ol", {
    className: "".concat(prefix, "--buttongroup"),
    "data-autoid": "".concat(stablePrefix, "--button-group"),
    ref: groupRef
  }, buttons.map(function (button, key) {
    return React.createElement("li", {
      key: key,
      className: "".concat(prefix, "--buttongroup-item")
    }, React.createElement(Button, _extends({
      "data-autoid": "".concat(stablePrefix, "--button-group-").concat(key)
    }, button, {
      type: "button",
      kind: key === buttons.length - 1 ? 'primary' : 'tertiary'
    }), button.copy));
  }));
};

export default ButtonGroup;